import { render, staticRenderFns } from "./ShortAddress.vue?vue&type=template&id=0436163a&scoped=true&"
import script from "./ShortAddress.vue?vue&type=script&lang=ts&"
export * from "./ShortAddress.vue?vue&type=script&lang=ts&"
import style0 from "./ShortAddress.vue?vue&type=style&index=0&id=0436163a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0436163a",
  null
  
)

export default component.exports